import * as React from "react";
import Message from "../../_data/models/Message";
import User from "../../_data/models/User";
import ConversationContainer from "../containers/ConversationContainer";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import Meta from "../../_data/models/Meta";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import {userByIdSelector} from "../../_data/selectors";
import * as moment from "moment";
import {getCurrentUser} from "../../_helpers/utils";
import {ConversationsRoutes} from "../../routes";
import {UsersRoutes} from "../../routes";
import {Link} from "react-router-dom";
import Conversation from "../../_data/models/User";


interface Props {
    state: any;
    messages: Message[];
    meta: Meta;
    recipient: User;
    loadMore: (conversationId:number, meta:Meta) => void;
    loading: boolean;
    sendMessage: () => void;
    composeMessage: (msg:string) => void;
    conversation: Conversation;
}

let timer:number = 0;
let shouldScrollToBottom:boolean = true;
let shouldScrollDown: boolean = false;
const perPage = 10;


const loadMoreMessagesWhenScrollingUp = (callback:()=>void, meta:Meta) => {
    document.onscroll = () => {        
       if(window.pageYOffset <= 100) {

           let messagesElemContainer = document.getElementsByClassName('in-messages');
           if(messagesElemContainer.length > 0 && meta.totalCount > perPage) {
               const messagesElem = messagesElemContainer[0].childNodes;
               const elemToScroll = messagesElem[perPage];           
               if(elemToScroll !== undefined) {
                   if ((messagesElem.length + 1) < meta.totalCount)
                       elemToScroll.scrollIntoView({ behavior: 'smooth' });                               
               } else {
                   messagesElem[1].scrollIntoView({ behavior: 'smooth' });                               
               }
           }
           
           callback();
           shouldScrollToBottom = false;       
       }
    };
}

const scrollToBottom = () => {  
    window.scrollTo(0,document.body.scrollHeight);
}

const handleOnKeyPress = (e, props: Props) => {       
    props.composeMessage(e.target.value);    
}

const handleOnSubmit = (e, props: Props) => {
    e.preventDefault();
    props.sendMessage();      
    const textArea = e.target.querySelectorAll('textarea')[0];
    textArea.value = "";
    textArea.focus();    
    shouldScrollToBottom = true;
}

const MessagesComponent = (props: Props) => {    
    const {messages, loadMore, meta, loading, state, recipient, conversation} = props;      
    loadMoreMessagesWhenScrollingUp(() => {
        if(!loading && (!meta || meta && meta.hasNext())){
            loadMore(conversation.id, meta);        
        }
    }, meta);

    let messagesList;
    let count:number = 0;     
    if(messages.length > 0) {  
        messagesList = (            
            <div className="in-messages profile">    
                {

                    messages.map((m, i)=> {    
                        if(m.senderId) {                           
                            const sender = userByIdSelector(state, m.senderId);                        
                            const hr = (i > 0 ? <hr className="marginless bb-1" />: null);  
    //                        console.log(sender);                            
                            return (  
                                <div key={count++}>       
                                    {hr}        
                                    <div className={sender.id == getCurrentUser().id ? 'row p1 mr-0 ml-0 reply' : 'row p1 mr-0 ml-0'}>
                                        <div className="large-12 column mb-1  small-img-fit">
                                            <img src={sender.profilePictureUrl} className="img-wrapper circle mr-half" />                                        
                                            <Link to={`${UsersRoutes.index()}/${sender.id}`}>
                                                {sender.username()}
                                            </Link>
                                            <label className="pull-right mt-half">{moment(m.createdAt).fromNow()}</label>
                                        </div>
                                        <div className="large-12 column">
                                            <p className="mb-0">{m.content}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    })
                }
            </div>                                                    
        );
    }     
    return (
        <div onLoad={()=>{
            if(meta == null || meta.currentPage == 1 || shouldScrollToBottom)
                scrollToBottom();
        }}>
            <div className="row">
                <div className="medium-6 column">
                    <nav aria-label="You are here:" role="navigation" className="mt-1 mb-1">
                        <ul className="breadcrumbs">
                            <li>                            
                                <Link to={ConversationsRoutes.index()}>
                                    All Messages
                                </Link>
                            </li>
                            <li>                                                            
                                 {recipient.fullName}                                
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="medium-6 column">
                    <div className="search-box mt-half mb-half">
                        <div className="pull-right search-box">
                            {/*<a data-open="composemessage" className="button small mb-0 hollow"><i className="fa fa-pencil fa-fw mr-half" aria-hidden="true" name=""></i>Compose Message</a>*/}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="medium-12 column">
                    <div className="panel">
                        <div className="p1 bb-1 disable">
                            <h4>Sed ut perspiciatis</h4>
                        </div>
                        {messagesList}
                        <div className="row p1 mr-0 ml-0 stick-bottom bt-1">
                            <form onSubmit={(e) => handleOnSubmit(e, props)}>
                                <div className="large-10 medium-10 small-9 column">
                                    <label>Reply</label>
                                    <textarea rows={2} onKeyUp={(e) => handleOnKeyPress(e,props)}></textarea>
                                </div>
                                <div className="large-2 medium-2 small-3 column send v-align-center">
                                    <button type="submit" className="mb-0 button middle p1">Send</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessagesComponent;


// WEBPACK FOOTER //
// ./app/client/message/components/MessagesComponent.tsx